var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackpack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 496 496",
    style: {
      enableBackground: "new 0 0 496 496"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5E6664"
    },
    d: "M96,112V23.2c0-12,4.8-23.2,16.8-23.2H168c12,0,24,11.2,24,23.2V48"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F423F"
    },
    d: "M112,0h56c12,0,24,11.2,24,23.2V48"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F423F"
    },
    d: "M400,112V23.2c0-12-7.2-23.2-19.2-23.2h-56c-12,0-20.8,11.2-20.8,23.2V48"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC114"
    },
    d: "M80,456H55.2c-28,0-23.2-25.6-23.2-53.6v-104c0-28,21.6-49.6,50.4-49.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCA12A"
    },
    d: "M32,367.2v34.4c0,28.8-4.8,54.4,23.2,54.4H80l1.6-138.4L32,367.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCA12A"
    },
    d: "M416,456h24.8c28,0,23.2-25.6,23.2-53.6v-104c0-28-21.6-49.6-50.4-49.6"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F15249"
    },
    d: "M425.6,404c0,50.4-40.8,92-91.2,92h-172c-50.4,0-91.2-41.6-91.2-92l18.4-264.8 C88.8,88.8,129.6,48,180,48h135.2c50.4,0,91.2,40.8,91.2,91.2L425.6,404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#45C2B3"
    },
    d: "M384,372c0,37.6-30.4,68-68,68H188c-37.6,0-68-30.4-68-68l0,0c0-37.6,30.4-68,68-68h128 C353.6,304,384,334.4,384,372L384,372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C93131"
    },
    d: "M407.2,139.2C407.2,88,366.4,48,316,48h-68v257.6L187.2,448l59.2,48h87.2c50.4,0,91.2-41.6,91.2-92 L407.2,139.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3CC676"
    },
    d: "M380,376c0,38.4-31.2,72-69.6,72h-64h-60.8c-38.4,0-69.6-33.6-69.6-72l0,0c0-38.4-5.6-72,32.8-72H248 h99.2C384.8,304,380,337.6,380,376L380,376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0AA06E"
    },
    d: "M248,304h98.4c38.4,0,32.8,33.6,32.8,72l0,0c0,38.4-31.2,72-69.6,72h-64H184"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C93131"
    },
    d: "M263.2,255.2c-8,8-21.6,8-30.4,0l-45.6-45.6c-8-8-8-21.6,0-30.4l45.6-45.6c8-8,21.6-8,30.4,0 l45.6,45.6c8,8,8,21.6,0,30.4L263.2,255.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC114"
    },
    d: "M260.8,236.8c-7.2,7.2-18.4,7.2-25.6,0L196,197.6c-7.2-7.2-7.2-18.4,0-25.6l39.2-39.2 c7.2-7.2,18.4-7.2,25.6,0L300,172c7.2,7.2,7.2,18.4,0,25.6L260.8,236.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8A15"
    },
    d: "M247.2,128c4.8,0,9.6,1.6,13.6,5.6l39.2,39.2c7.2,7.2,7.2,18.4,0,25.6l-39.2,39.2 c-3.2,3.2-8,5.6-12.8,5.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F423F"
    },
    d: "M240,199.2c0,2.4-4.8,4.8-8,4.8l0,0c-3.2,0-8-2.4-8-4.8v-28c0-2.4,4.8-4.8,8-4.8l0,0 c3.2,0,8,2.4,8,4.8V199.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F423F"
    },
    d: "M272,199.2c0,2.4-4.8,4.8-8,4.8l0,0c-3.2,0-8-2.4-8-4.8v-28c0-2.4,4.8-4.8,8-4.8l0,0 c3.2,0,8,2.4,8,4.8V199.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackpack);
export default __webpack_public_path__ + "static/media/backpack.a362a82a5091695721161709cf60a824.svg";
export { ForwardRef as ReactComponent };